/**
 * Route for `duplicate-conversion-prevention`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DuplicateConversionPreventionPage } from "../features/duplicate-conversion-prevention/DuplicateConversionPreventionPage";

export const duplicateConversionPreventionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/duplicate-conversion-prevention",
	component: DuplicateConversionPreventionPage,
});

export default duplicateConversionPreventionRoute;
